import { FGStack, FGTypography } from '@fg/design-system';
import { E_RISK_TYPE } from 'interfaces';
import React from 'react';
import { InsightAndEventBadge } from './EventDisplay';
import { getRiskLongName } from 'utils/riskUtils';

const RiskBadge = React.memo(
    ({ risk }: { risk: { type: E_RISK_TYPE; id: number } }) => {
        return (
            <InsightAndEventBadge>
                <FGStack gap={4}>
                    <FGTypography
                        variant="body4"
                        tag="label"
                        cssStyle={{ whiteSpace: 'nowrap' }}>
                        {getRiskLongName(risk.type, risk.id)}
                    </FGTypography>
                </FGStack>
            </InsightAndEventBadge>
        );
    }
);

export default RiskBadge;
